import React from 'react'
import Box from './Box'

const Card = props => (
  <Box boxShadow="0 0 9px 0px rgba(1,1,1,.1)" borderRadius="4px" backgroundColor="white" {...props}>
    {props.children}
  </Box>
)

export default Card



// WEBPACK FOOTER //
// ./src/UILibrary/Card.js